import CONSTANTS from "./constants";
import { call, put, takeLatest } from "redux-saga/effects";
import * as SERVICES from "./services";
import parseError from "@src/utils/parseError";
import { checkMmServiceEnabledOnCourses } from "@src/utils/liveService/util";

function* getUpcomingClassesSaga(data) {
  if (!data?.payload?.skipLoader) {
    yield put({
      type: CONSTANTS.UPCOMINGCLASSES_LIST_LOADING,
      payload: true,
    });
  }

  try {
    const { isPurchased } = data?.payload;
    let apiRes, apiCall
    const mmServiceEnabledOnCourses = checkMmServiceEnabledOnCourses()
    if (mmServiceEnabledOnCourses){
      apiCall = yield call(SERVICES.getNewServiceUpcomingClassesAndLiveCard, data?.payload)
      apiRes = apiCall?.data?.data
      apiRes = {...apiRes, totalCount: apiRes?.totalCount}
    } else{
      apiCall = yield call(
        SERVICES.getUpcomingClassesService,
        data?.payload
      );
      apiRes = apiCall?.data?.data;
    }

    if (data?.payload?.offset === 0) {
      yield put({
        type: CONSTANTS.UPCOMINGCLASSES_APIRES_SUCCESS,
        payload: apiRes,
      });
    }
    yield put({
      type: CONSTANTS.UPCOMINGCLASSES_LIST_SUCCESS,
      payload: {
        list: isPurchased ? apiRes.list : mmServiceEnabledOnCourses ? apiRes?.list : apiRes?.data,
        offset: data?.payload?.offset,
        totalCount: apiRes?.totalCount,
        currentList: data?.payload?.currentList,
      },
    });
  } catch (err) {
    parseError(err);
  }
}

export default function* actionWatcher() {
  yield takeLatest(CONSTANTS.UPCOMINGCLASSES_LIST_GET, getUpcomingClassesSaga);
}
